module.exports = __webpack_public_path__ + "img/halteknop02.fc1a3752.png";